<template>
  <div class="social" :class="{ expanded: expanded, sharetoggle: shareToggle }">

    <div ref="iconWrap" class="icon-wrap d-flex align-items-center">

      <a ref="shareIcon" href="#" class="share" @click.prevent="handleExpand" v-if="shareToggle">
        <p class="share-text">Share</p>

        <svg class="icon-share" width="30px" height="38px" viewBox="0 0 16 20" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.74597327,12.439868 C4.25414864,12.7924447 3.65131289,13 3,13 C1.34314575,13 0,11.6568542 0,10 C0,8.34314575 1.34314575,7 3,7 C3.71450534,7 4.37067038,7.2497845 4.88593632,7.6667947 L10.1634677,3.97927896 C10.0575312,3.67237361 10,3.34290537 10,3 C10,1.34314575 11.3431458,0 13,0 C14.6568542,0 16,1.34314575 16,3 C16,4.65685425 14.6568542,6 13,6 C12.4171716,6 11.8731616,5.83379809 11.4127797,5.54620367 L5.93457655,9.37393274 C5.97744549,9.57586055 6,9.78529633 6,10 C6,10.2773103 5.96237414,10.5458326 5.89194905,10.8007402 L11.2630881,14.5536615 C11.7532474,14.2050173 12.3526815,14 13,14 C14.6568542,14 16,15.3431458 16,17 C16,18.6568542 14.6568542,20 13,20 C11.3431458,20 10,18.6568542 10,17 C10,16.7188002 10.0386887,16.4466367 10.1110336,16.1885419 L4.74597327,12.439868 Z"
            fill="#FFFFFF"></path>
        </svg>
      </a>

      <div ref="socialLinksWrap" class="social-links">

        <a ref="facebook" class="social-link" href="#" @click.prevent="openWindow('https://www.facebook.com/sharer/sharer.php?u='
        + encUrl, 'Facebook')">
          <svg class="icon-fb" width="11px" height="22px" viewBox="0 0 7 14" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0,4.62990182 L1.49963441,4.62990182 L1.49963441,3.22323476 C1.49963441,2.60344523 1.51498903,1.64618731 1.98245186,1.05438297 C2.47379966,0.427185608 3.14940288,0 4.31123568,0 C6.20241287,0 7,0.260920689 7,0.260920689 L6.62551791,2.40507966 C6.62551791,2.40507966 5.99939069,2.23058381 5.41676822,2.23058381 C4.83329271,2.23058381 4.31123568,2.43224175 4.31123568,2.99523782 L4.31123568,4.62990182 L6.70314404,4.62990182 L6.53594931,6.72385208 L4.31123568,6.72385208 L4.31123568,14 L1.49963441,14 L1.49963441,6.72385208 L0,6.72385208 L0,4.62990182 Z"
              fill="#FFFFFF"></path>
          </svg>
        </a>

        <a ref="twitter" class="social-link" href="#" @click.prevent="openWindow('https://twitter.com/intent/tweet?text=' + encDesc + '&url=' + encUrl + '&via=Adobe', 'Twitter')">
          <svg class="icon-twitter" width="22px" height="18px" viewBox="0 0 14 11" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14,1.30210891 C13.4855902,1.52296692 12.9317368,1.67232414 12.350766,1.73905821 C12.9448847,1.3958544 13.4001291,0.851653907 13.61296,0.203380038 C13.0582849,0.5219558 12.4444444,0.752347248 11.7895169,0.876281959 C11.2668897,0.336848187 10.5191055,0 9.69325585,0 C8.10729589,0 6.82127135,1.24331937 6.82127135,2.77661418 C6.82127135,2.99429438 6.84592358,3.20561895 6.89522803,3.40899899 C4.50807067,3.29300881 2.39290955,2.18871876 0.974584727,0.507655641 C0.728062452,0.919182435 0.585901274,1.3958544 0.585901274,1.90430449 C0.585901274,2.86718186 1.09291542,3.71724686 1.8637084,4.21536906 C1.39285085,4.20186335 0.9499325,4.07554528 0.562070787,3.86898743 L0.562070787,3.90314892 C0.562070787,5.24895277 1.55226859,6.37151524 2.86705406,6.62574029 C2.62546223,6.69088545 2.37318777,6.72345804 2.10940893,6.72345804 C1.92533897,6.72345804 1.74455597,6.70677452 1.57034689,6.67420194 C1.93437812,7.77690308 2.99524564,8.58088979 4.25250924,8.60154557 C3.26970711,9.34674274 2.03134355,9.79084212 0.685331925,9.79084212 C0.454422727,9.79084212 0.22433527,9.77813087 0,9.75270836 C1.2712332,10.5392171 2.781593,11 4.40288783,11 C9.68668193,11 12.575923,6.76874187 12.575923,3.09916221 C12.575923,2.97840532 12.572636,2.85764842 12.5677056,2.74006933 C13.1289546,2.34760942 13.616247,1.85902066 14,1.30210891"
              fill="#FFFFFF"></path>
          </svg>
        </a>

        <a ref="linkedin" class="social-link" href="#" @click.prevent="openWindow('https://www.linkedin.com/shareArticle?mini=true&url=' + encUrl + '&title=' + encTitle + '&summary=' + encDesc + '&source=Adobe', 'LinkedIn')">
          <svg class="icon-linkedin" width="22px" height="21px" viewBox="0 0 14 13" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14,13 L10.905809,13 L10.905809,8.42998015 C10.905809,7.2337837 10.4226246,6.41717359 9.35747883,6.41717359 C8.54339135,6.41717359 8.09066322,6.96823974 7.87993885,7.49932766 C7.80174036,7.68995326 7.81326435,7.95466479 7.81326435,8.22104117 L7.81326435,13 L4.74788335,13 C4.74788335,13 4.78821731,4.90465518 4.74788335,4.16879042 L7.81326435,4.16879042 L7.81326435,5.55478005 C7.9943556,4.94877377 8.97389464,4.08388295 10.5378645,4.08388295 C12.4763641,4.08388295 14,5.35416533 14,8.08951783 L14,13 Z M1.64793039,3.06332842 L1.62899812,3.06332842 C0.641227658,3.06332842 0,2.38823077 0,1.53332906 C0,0.660946405 0.660159925,0 1.66768579,0 C2.67356538,0 3.2925682,0.659281552 3.31314675,1.53083179 C3.31314675,2.38656592 2.67356538,3.06332842 1.64793039,3.06332842 Z M0.35312794,13 L3.08266698,13 L3.08266698,4.16879042 L0.35312794,4.16879042 L0.35312794,13 Z"
              fill="#FFFFFF"></path>
          </svg>
        </a>

      </div>

    </div>

  </div>
</template>

<script>
  import StateMixin from '@/components/report/mixins/StateMixin'
  import { TweenMax, Power2, Sine } from 'gsap'

  export default {
    name: 'Social',
    mixins: [ StateMixin ],
    data () {
      return {
        'expanded': false
      }
    },
    props: [ 'shareToggle' ],
    methods: {
      handleExpand () {
        let iconEls = [ this.$refs.facebook, this.$refs.twitter, this.$refs.linkedin ]
        if ( !this.expanded ) {
          TweenMax.to( this.$refs.iconWrap, 0.6, {
            width: (this.$refs.shareIcon.clientWidth + this.$refs.socialLinksWrap.clientWidth),
            ease: Power2.easeOut
          } )
          TweenMax.staggerTo( iconEls, 0.5, { autoAlpha: 1, ease: Sine.easeOut, delay: 0.2 }, 0.05 )
        } else {
          TweenMax.to( this.$refs.iconWrap, 0.6, { width: this.$refs.shareIcon.clientWidth, ease: Power2.easeOut } )
          TweenMax.staggerTo( iconEls, 0.5, { autoAlpha: 0, ease: Sine.easeOut, delay: 0 }, 0.05 )
        }
        this.expanded = !this.expanded
      },
      openWindow ( url, network ) {
        window.open( url, 'Share to ' + network, 'height=350,width=600' )
      }
    },
    mounted () {
      if ( this.shareToggle ) {
        TweenMax.set( this.$refs.iconWrap, { width: this.$refs.shareIcon.clientWidth } )
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/scss/global/the_goods';

  .social {
    position : relative;
    z-index  : 1;
  }

  .sharetoggle {
    white-space : nowrap;

    path {
      transition : fill 0.2s cubic-bezier(.215, .61, .355, 1);
    }

    .social-link {
      opacity : 0;
      margin  : 0 7px;

      .darken & {
        path {
          fill : black;
        }
      }
    }

    svg {
      position : relative;
      top      : 2px;
    }

    .share {
      display       : inline-block;
      padding-right : 20px;
    }

    .icon-share {
      width  : 17px;
      height : 22px;

      path {

        .darken & {
          fill : black;
        }
      }
    }

    .icon-fb {
      width  : 8px;
      height : 16px;
    }

    .icon-twitter {
      width  : 16px;
      height : 13px;
    }

    .icon-linkedin {
      width        : 16px;
      height       : 15px;
      margin-right : 15px;
    }

    a {
      text-decoration : none;
    }

    .share-text {
      display     : inline-block;
      color       : white;
      font-size   : .9375rem;
      font-weight : 700;
      margin      : 0 .4375rem 0 0;
      transform   : translateY(-5px);
      transition  : all .2s cubic-bezier(.215, .61, .355, 1) 0s;

      .darken & {
        color : black;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/Social.vue